import { put, call, all, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/transferSecurity'
import {
  getTransferSecurity,
  getRentAccountContract,
  getMarginAccountContract
} from 'services'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { REQUEST_ERROR } from 'config/messages'

const {
  TRANSFER_SECURITY_REQUEST,
  TRANSFER_SECURITY_SUCCESS,
  TRANSFER_SECURITY_ERROR,

  RENT_ACCOUNT_CONTRACT_REQUEST,
  RENT_ACCOUNT_CONTRACT_SUCCESS,
  RENT_ACCOUNT_CONTRACT_ERROR,

  MARGIN_ACCOUNT_CONTRACT_REQUEST,
  MARGIN_ACCOUNT_CONTRACT_SUCCESS,
  MARGIN_ACCOUNT_CONTRACT_ERROR
} = ACTION_TYPES

export function *transferSecurity() {
  try {
    const response = yield call(getTransferSecurity)
    yield put({ type: TRANSFER_SECURITY_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: TRANSFER_SECURITY_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *rentAccountContract() {
  try {
    const response = yield call(getRentAccountContract)
    yield put({ type: RENT_ACCOUNT_CONTRACT_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: RENT_ACCOUNT_CONTRACT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *marginAccountContract() {
  try {
    const response = yield call(getMarginAccountContract)
    yield put({ type: MARGIN_ACCOUNT_CONTRACT_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: MARGIN_ACCOUNT_CONTRACT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export default function *watchTransferSecurity() {
  yield all([
    takeLatest(TRANSFER_SECURITY_REQUEST, transferSecurity),
    takeLatest(RENT_ACCOUNT_CONTRACT_REQUEST, rentAccountContract),
    takeLatest(MARGIN_ACCOUNT_CONTRACT_REQUEST, marginAccountContract)
  ])
}
